export default {
  setUser: (state, user) => (state.user = user),
  setAuthState: (state, authState) => (state.isLoggedIn = authState),
  setToken: (state, token) => (state.token = token)
}
